import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { ArtworkSummary } from "@eaf/contracts";

export function ArtworkCard({ artwork }: { artwork: ArtworkSummary }) {
  return (
    <Card className="artwork-card h-100">
      <div className="artwork-card__image">
        <Card.Img src={artwork.image.md} alt={artwork.title ?? "Untitled artwork"} loading="lazy" />
      </div>
      <Card.Body>
        <Card.Title>
          <Link
            className="stretched-link text-reset text-decoration-none"
            to={`/artwork/${encodeURIComponent(artwork.id)}`}
            aria-label={`View ${artwork.title || "artwork"}`}
          >
            {artwork.title || "Untitled"}
          </Link>
        </Card.Title>
        <Card.Text>
          {[artwork.paper, artwork.medium].filter(Boolean).join(" · ") || "Collection artwork"}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
